import styled, { css } from "styled-components";

/**
 * Controles do projetista do executivo. Discretos de propósito: na tabela
 * parecem texto até o mouse chegar (a borda só aparece em hover/foco), e
 * nenhuma cor além do neutro — cor nesta tela é só estado de prazo.
 */
const controleDaCelula = css`
  width: 100%;
  min-width: 0;
  height: 24px;
  padding: 0 4px;
  font: inherit;
  color: ${({ theme }) => theme.textPrimary};
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.16s ease, background 0.16s ease;

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: ${({ theme }) => theme.border};
    background: ${({ theme }) => theme.surface};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 1px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.55;
  }
`;

export const SelectDaCelula = styled.select`
  ${controleDaCelula}
  text-overflow: ellipsis;
  color: ${({ theme, $vazio }) => ($vazio ? theme.textTertiary : theme.textPrimary)};
`;

export const DataDaCelula = styled.input`
  ${controleDaCelula}
  cursor: text;
`;

export const Bloqueado = styled.span`
  color: ${({ theme }) => theme.textTertiary};
  cursor: help;
`;

// ---------------------------------------------------------------- carga

export const Carga = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin: 4px 0 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const RotuloDaCarga = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.textTertiary};
  margin-right: 2px;
`;

export const Ficha = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 0 10px;
  font: inherit;
  font-size: 13px;
  color: ${({ theme, $ativo }) => ($ativo ? theme.textPrimary : theme.textSecondary)};
  font-weight: ${({ $ativo }) => ($ativo ? 600 : 500)};
  background: ${({ theme, $ativo }) => ($ativo ? theme.surfaceAlt : theme.surface)};
  border: 1px solid ${({ theme, $ativo }) => ($ativo ? theme.accent : theme.border)};
  box-shadow: ${({ theme, $ativo }) => ($ativo ? `0 0 0 1px ${theme.accent}` : "none")};
  border-radius: 999px;
  cursor: pointer;
  transition: border-color 0.16s ease, color 0.16s ease;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }

  strong {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: ${({ theme }) => theme.textPrimary};
  }
`;

export const BotaoTexto = styled.button`
  min-height: 28px;
  padding: 0 4px;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.accent};
  background: none;
  border: 0;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    text-decoration: none;
  }
`;

export const Empurrar = styled.span`
  flex: 1 1 auto;
`;

// ------------------------------------------------------- linha do tempo

export const BlocoDaEtapa = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const LinhaDaPassagem = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 6px;

  strong {
    font-weight: 600;
    color: ${({ theme, $atual }) => ($atual ? theme.textPrimary : theme.textSecondary)};
  }

  span {
    color: ${({ theme }) => theme.textTertiary};
  }
`;

export const Editor = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px;
  gap: 8px;
  margin-top: 4px;

  @media (max-width: 480px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Campo = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};

  select,
  input {
    width: 100%;
    min-width: 0;
    height: 36px;
    padding: 0 10px;
    font: inherit;
    font-size: 14px;
    color: ${({ theme }) => theme.textPrimary};
    background: ${({ theme }) => theme.surface};
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 8px;
  }

  select:focus-visible,
  input:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 1px;
  }
`;

export const AcoesDoEditor = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Nota = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.textTertiary};
`;

// ----------------------------------------------------------------- lote

export const FormularioDoLote = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 150px;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const CabecalhoDaSelecao = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const Grupo = styled.section`
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const Marcavel = styled.label`
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-height: ${({ $grupo }) => ($grupo ? "32px" : "36px")};
  padding-left: ${({ $grupo }) => ($grupo ? "0" : "28px")};
  font-size: ${({ $grupo }) => ($grupo ? "13px" : "14px")};
  font-weight: ${({ $grupo }) => ($grupo ? 600 : 400)};
  color: ${({ theme }) => theme.textPrimary};
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: ${({ theme }) => theme.accent};
  }

  .texto {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .quem {
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.textTertiary};
    white-space: nowrap;
  }
`;
